import script from "./GradeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeSelection.vue?vue&type=script&setup=true&lang=js"

import "./GradeSelection.vue?vue&type=style&index=0&id=6ae0e84c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae0e84c"]])

export default __exports__